import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, DatePicker, Checkbox, Upload, Icon } from 'antd'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
var IconAwesome = require('react-fontawesome');
const axios = require('axios')
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const MonthPicker = DatePicker.MonthPicker;

class IncomeNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            hotels: [],
            expense_types: [],
            companies: [],
            filterByHotel: '',
            imageUrl: '',
            file: {}
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        if (this.props.incomeType === 'cash_funds_trie' || this.props.incomeType === 'others_trie' || this.props.incomeType === 'payroll_trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {

        // Query Hotel
        let queryHotel = {};
        this.state.currentHotel ? queryHotel.objectId = this.state.currentHotel.objectId : null;

        // Consulta los hoteles
        all('Hotel', {where: queryHotel, limit: 100}).then((resp) => {
            if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: resp.results[0].objectId, label: resp.results[0].name}});
            this.setState({
                hotels: resp.results
            });
        })


        // Query Tipo de movimiento
        let queryType = {};
        queryType.type = 'principal';
        this.state.currentHotel ? queryType.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId} : null;

        // Consulta los tipos de gastos
        if (this.props.incomeType !== 'payments') {
            all('ExpenseType', {where: queryType, limit: 100}).then((resp) => {
                this.setState({
                    expense_types: resp.results
                });

                if (this.props.incomeId)
                    this.getIncome();
            })

        } else {
            all('PaymentType', {where: queryType, limit: 100}).then((resp) => {
                this.setState({
                    expense_types: resp.results
                });

                if (this.props.incomeId)
                    this.getIncome();
            })
        }
    }


    /**
    * Obtiene la información del registro
    */
    getIncome () {
        this.props.dispatch({type: 'app/showLoadingTable'})
        get('Income', this.props.incomeId, {include: 'hotel,expense,expense.parent_category,payment,payment.parent_category'}).then((resp) => {

            resp.requestedAt = moment(new Date(resp.requestedAt.iso), 'YYYY/MM/DD');
            if (resp.hotel) resp.hotel = {key: resp.hotel.objectId, label: resp.hotel.name};
            if (resp.picture) this.setState({ imageUrl: resp.picture });

            if (resp.chargedTo && resp.chargedTo === 'caja') resp.chargedTo = {key: 'caja', label: 'Caja'};
            if (resp.chargedTo && resp.chargedTo === 'propietario') resp.chargedTo = {key: 'propietario', label: 'Efectivo ' + this.state.currentHotel.chief};
            if (resp.chargedTo && resp.chargedTo === 'trie') resp.chargedTo = {key: 'trie', label: 'Pago Directo TRIE'};
            
            if (resp.status && resp.status === 'pending') resp.status = {key: resp.status, label: 'Pendiente'};
            if (resp.status && resp.status === 'paidout') resp.status = {key: resp.status, label: 'Pagado'};

            if (resp.type !== 'payments') {
                // Se asignan los valores del catálogo de caja chica

                if (resp.expense && resp.expense.parent_category) {
                    // Sub categoria
                    // resp.expense contiene una subcategoría o secundario
                    // resp.expense.parent_category contiene el principal

                    resp.expense.parent_category.children = [resp.expense];

                    this.setState({ 
                        expense_selected: resp.expense.parent_category,
                        subexpense_selected: resp.expense,
                    });

                    resp.expense_type = {key: resp.expense.parent_category.objectId, label: resp.expense.parent_category.name};
                    resp.subexpense_type = {key: resp.expense.objectId, label: resp.expense.name};

                } else {
                    // Categoría principal

                    resp.expense.children = [];
                    this.setState({ expense_selected: resp.expense})
                    resp.expense_type = {key: resp.expense.objectId, label: resp.expense.name};
                }

            } else {
                // Se asignan los valores del catálogo de pagos

                if (resp.payment && resp.payment.parent_category) {
                    // Sub categoria
                    // resp.payment contiene una subcategoría o secundario
                    // resp.payment.parent_category contiene el principal

                    resp.payment.parent_category.children = [resp.payment];

                    this.setState({ 
                        expense_selected: resp.payment.parent_category,
                        subexpense_selected: resp.payment,
                    })

                    resp.expense_type = {key: resp.payment.parent_category.objectId, label: resp.payment.parent_category.name};
                    resp.subexpense_type = {key: resp.payment.objectId, label: resp.payment.name};

                } else {
                    // Categoría principal

                    resp.payment.children = [];
                    this.setState({ expense_selected: resp.payment})
                    resp.expense_type = {key: resp.payment.objectId, label: resp.payment.name};
                }
            }

            // Desde el inicio se consultan los jefes o empresas y los tipos de gastos del hotel
            this.setState({ filterByHotel: resp.hotel.key })
            
            this.props.form.setFieldsValue(resp);
            this.props.dispatch({type: 'app/hideLoadingTable'})
        })
    }


    /**
    * Renderiza la imagen
    */
    getBase64 (img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }


    /**
    * Validaciones antes de subir la imagen
    */
    beforeUpload (file) {
        const isJPEG = file.type === 'image/jpeg';
        const isJPG = file.type === 'image/jpg';
        const isPNG = file.type === 'image/png';
        if (!isJPG && !isJPEG && !isPNG) {
            message.error('El formato de la imagen is inválido!');
        }

        const isLt2M = file.size / 1024 / 1024 < 5;
        if (!isLt2M) {
            message.error('La imagen debe ser menor a 5MB!');
        }

        this.setState({file: file, loading: true});
        return (isJPG || isJPEG || isPNG) && isLt2M;
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchHotel (value, callback) {
        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        this.props.form.setFieldsValue({ expense_type: {key: ''} });      

        if (value && value.key && !value.label) {
            this.fetchHotel(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }

        // Key trae el ID del hotel, entonces se consulta los clientes de dicho hotel
        if (value && value.key && value.label) {
            this.setState({ filterByHotel: value.key })

            setTimeout(() => {
                // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre
                // en éste caso no estamos consultando por nombre sino por hotel
                this.fetchExpenseTypes('', (expense_types) => {
                    this.setState({ expense_types: expense_types })
                });

                this.fetchCompanies('', (companies) => {
                    this.setState({ companies: companies })
                });
            }, 100);
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el cliente!');
        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchExpenseTypes (value, callback) {
        // Query
        let query = {name: {$regex: '(?i)' + value}, type: 'principal'};
        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

        if (this.state.filterByHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.filterByHotel}

        setTimeout(() => {
            if (this.props.incomeType !== 'payments') {
                all('ExpenseType', {where: query}).then((d) => {
                    const results = d.results;
                    callback(results);

                }).catch(e => {
                    message.error('No hemos podido consultar los registros del hotel seleccionado. Intente de nuevo')    
                });

            } else {
                all('PaymentType', {where: query}).then((d) => {
                    const results = d.results;
                    callback(results);

                }).catch(e => {
                    message.error('No hemos podido consultar los registros del hotel seleccionado. Intente de nuevo')    
                });
            }
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectExpenseTypeChange (value) {
        if (value && value.key && !value.label) {
            this.fetchExpenseTypes(value.key, (resp) => {
                this.setState({ expense_types: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un ExpenseType de la lista
    */
    checkExpenseType (rule, value, callback) {
        this.props.dispatch({type: 'app/showLoadingTable'})

        // Limpiamos el valor de la sub categoría cada vez que se cambie la categoría principal
        if (this.props.form.getFieldValue('subexpense_type')) {
            this.props.form.resetFields(['subexpense_type'])
        }

        if (value && !value.label) {
            this.props.dispatch({type: 'app/hideLoadingTable'})

            // Si el campo está en blanco, entonces consultamos todos los movimientos principales nuevamente
            if (value.key === '') {
                this.fetchExpenseTypes('', (resp) => {
                    console.log(resp);
                    this.setState({ expense_types: resp })
                });
            }

            callback('Por favor, elija el tipo de movimiento');

        } else if (value) {
            let expenseSelected = _.find(this.state.expense_types, {objectId: value.key});

            if (this.props.incomeType !== 'payments') {
                all('ExpenseType', {
                    where: {
                        parent_category: {__type: 'Pointer', className: 'ExpenseType', objectId: expenseSelected.objectId}
                    },
                    limit: 1000
                }).then((d) => {
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    expenseSelected.children = d.results;
                    this.setState({ 
                        expense_selected: expenseSelected,
                        subexpense_selected: null
                    });
                });
            } else {
                all('PaymentType', {
                    where: {
                        parent_category: {__type: 'Pointer', className: 'PaymentType', objectId: expenseSelected.objectId}
                    },
                    limit: 1000
                }).then((d) => {
                    this.props.dispatch({type: 'app/hideLoadingTable'})

                    expenseSelected.children = d.results;
                    this.setState({ 
                        expense_selected: expenseSelected,
                        subexpense_selected: null
                    });
                });
            }

            callback();
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un Sub Expense de la lista
    */
    checkSubExpenseType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el movimiento');

        } else if (value) {
            let subExpenseSelected = _.find(this.state.expense_selected.children, {objectId: value.key});
            this.setState({ subexpense_selected: subExpenseSelected });

            callback();
        } else {
            callback();
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchCompanies (value, callback) {
        // Query
        let query = {name: {$regex: '(?i)' + value}, type: 'company'};
        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

        if (this.state.filterByHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.filterByHotel}

        setTimeout(() => {
            all('Employee', {where: query}).then((d) => {
                const results = d.results;
                callback(results);

            }).catch(e => {
                message.error('No hemos podido consultar algunos registros del hotel seleccionado. Intente de nuevo')    
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectCompanyChange (value) {
        if (value && value.key && !value.label) {
            this.fetchCompanies(value.key, (resp) => {
                this.setState({ companies: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un Company de la lista
    */
    checkChargedTo (rule, value, callback) {
        console.log('value', value);
        if (value && !value.label && value.key !== '') {
            callback('Por favor, elija el dueño');

        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.-]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data.requestedAt = {__type: 'Date', iso: new Date(values.requestedAt).toISOString()};
            data.notified = false;

            if (this.state.currentHotel)
                data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId};

            if (this.props.chargedTo) {
                this.props.chargedTo === 'trie' ? data.type = this.props.incomeType + '_trie' : data.type = this.props.incomeType.slice(0, -5);
                data.status = 'requested';
            } else {
                data.type = this.props.incomeType;
                data.status = values.status.key;
            }

            // Asignamos el puntero del sub expense (si hubiera) o el expense principal (si no tiene sub categorias)
            if (this.props.incomeType !== 'payments') {
                if (this.state.subexpense_selected)
                    data.expense = {__type: 'Pointer', className: 'ExpenseType', objectId: this.state.subexpense_selected.objectId};
                else
                    data.expense = {__type: 'Pointer', className: 'ExpenseType', objectId: this.state.expense_selected.objectId};

            } else {
                if (this.state.subexpense_selected)
                    data.payment = {__type: 'Pointer', className: 'PaymentType', objectId: this.state.subexpense_selected.objectId};
                else
                    data.payment = {__type: 'Pointer', className: 'PaymentType', objectId: this.state.expense_selected.objectId};
            }


            // Montos de ingresos o egresos
            if (values.amount_income)
                _.isNumber(values.amount_income) ? data.amount_income = values.amount_income : data.amount_income = Number(values.amount_income.replace(/[^\d.-]/g, ''))
            else
                data.amount_income = 0;

            if (values.amount_expense)
                _.isNumber(values.amount_expense) ? data.amount_expense = values.amount_expense : data.amount_expense = Number(values.amount_expense.replace(/[^\d.-]/g, ''))
            else
                data.amount_expense = 0;

            if (values.adjustment)
                _.isNumber(values.adjustment) ? data.adjustment = values.adjustment : data.adjustment = Number(values.adjustment.replace(/[^\d.-]/g, ''))
            else
                data.adjustment = 0;


            // Si se le asignó el cargo a un dueño
            if (values.chargedTo)
                data.chargedTo = values.chargedTo.key;
            else
                data.chargedTo = null;

            // Si se subio el comprobante del income
            if (this.state.file && this.state.file.uid)
                data.picture = this.state.file.uid + '.jpg';


            // Removemos las variables que no se guardaran en la bd
            data = _.omit(data, ['expense_type', 'subexpense_type']);
            
            if (!this.props.incomeId) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Income', data).then(resp => {

                    _.extend(data, resp);
                    data.expense = {objectId: values.expense_type.key, name: values.expense_type.label};

                    if (values.hotel && values.hotel.key) {
                        data.hotel = {objectId: values.hotel.key, name: values.hotel.label};
                    }

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el registro exitosamente');

                    if (this.state.currentHotel)
                        this.props.form.resetFields(['expense_type', 'subexpense_type', 'amount_expense', 'amount_income', 'adjustment', 'employee', 'items', 'chargedTo', 'notes']);
                    else
                        this.props.form.resetFields();

                    // Se resetean los valores seleccionados del select de movimientos
                    this.setState({ 
                        expense_selected: null,
                        subexpense_selected: null
                    });

                    axios({
                        url: config.api + 'jobs/set_hotel_totals',
                        method: 'POST',
                        headers: {
                            'X-Parse-Application-Id': config.appId,
                            'X-Parse-Master-Key': config.masterKey
                        },
                    });

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.props.incomeId;
                data.parentId = this.props.parentId;
                this.props.dispatch({type: 'income/update', payload: data})

                axios({
                    url: config.api + 'jobs/set_hotel_totals',
                    method: 'POST',
                    headers: {
                        'X-Parse-Application-Id': config.appId,
                        'X-Parse-Master-Key': config.masterKey
                    },
                });

                //this.props.form.resetFields();
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const expense_types_options = this.state.expense_types.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const companies_options = this.state.companies.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div>
                <Form onSubmit={this.handleSubmit.bind(this)}>
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="row">
                            <div className="col-md-12 marginBottom10 color-blue">
                                Los campos marcados con <span className="color-red text-bold">*</span> son obligatorios.<br />
                                {this.props.chargedTo && this.props.chargedTo === 'trie' ? 'Usted está solicitando el movimiento para ser atendido por TRIE Hotels' : ''}
                                {this.props.chargedTo && this.props.chargedTo === 'hotel' ? 'Usted está solicitando el movimiento para ser atendido por el Hotel' : ''}
                            </div>
                        </div>

                        <div className="row marginBottom10">
                            <div className="col-md-12 heading">
                                Información
                            </div>

                            {this.props.incomeType === 'payments'
                               ? <div className="col-md-3">
                                    <FormItem label="Mes" hasFeedback>
                                        {this.props.form.getFieldDecorator('requestedAt', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, seleccione el mes',
                                            }]
                                        })(
                                            <MonthPicker />
                                        )}
                                    </FormItem>
                                </div>
                                : <div className="col-md-3">
                                    <FormItem label="Fecha" hasFeedback>
                                        {this.props.form.getFieldDecorator('requestedAt', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, seleccione la fecha',
                                            }]
                                        })(
                                            <DatePicker format="DD-MM-YYYY" />
                                        )}
                                    </FormItem>
                                </div>
                            }

                            {this.props.incomeType === 'cash_funds' || this.props.incomeType === 'cash_funds_trie'
                                ? <div className="col-md-3">
                                    <FormItem label="Empleado en turno">
                                        {this.props.form.getFieldDecorator('user')(<Input size='large' />)}
                                    </FormItem>
                                </div>
                                : null
                            }

                            {this.props.incomeType !== 'payments'
                                ? <div className="col-md-3">
                                    <FormItem label="Asignado a" hasFeedback>
                                        {this.props.form.getFieldDecorator('chargedTo', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija una opción',
                                            }, {
                                                validator: this.checkChargedTo.bind(this)
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                >
                                                <Option key="caja" label="Caja">Caja</Option>
                                                <Option key="propietario" label={'Efectivo ' + this.state.currentHotel.chief}>Efectivo {this.state.currentHotel.chief}</Option>
                                                <Option key="trie" label="Pagos Directo TRIE">Pagos Directo TRIE</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                </div>
                                : <div className="col-md-3">
                                    <FormItem label="Asignado a" hasFeedback>
                                        {this.props.form.getFieldDecorator('chargedTo', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija una opción',
                                            }, {
                                                validator: this.checkChargedTo.bind(this)
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                >
                                                <Option key="propietario" label={this.state.currentHotel.chief}>{this.state.currentHotel.chief}</Option>
                                                <Option key="trie" label="TRIE">TRIE</Option>
                                            </Select>
                                        )}
                                    </FormItem>
                                </div>
                            }

                            <div className="col-md-3">
                                <FormItem label="Status" hasFeedback>
                                    {this.props.form.getFieldDecorator('status', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija una opción',
                                        }]
                                    })(
                                        <Select 
                                            size='large'
                                            filterOption={false}
                                            labelInValue={true}
                                            optionLabelProp='label'
                                            >
                                            <Option key="pending" label="Pendiente">Pendiente</Option>
                                            <Option key="paidout" label="Pagado">Pagado</Option>
                                        </Select>
                                    )}
                                </FormItem>
                            </div>
                        </div>

                        <div className="row marginBottom10">
                            <div className="col-md-12 heading">
                                Movimiento
                            </div>

                            <div className="col-md-4">
                                <FormItem label="Movimiento" hasFeedback>
                                    {this.props.form.getFieldDecorator('expense_type', {
                                        rules: [{
                                            required: true,
                                            message: 'Por favor, elija el tipo de ingreso / gasto',
                                        }, {
                                            validator: this.checkExpenseType.bind(this)
                                        }]
                                    })(
                                        <Select 
                                            size='large'
                                            mode="combobox"
                                            onChange={this.handleSelectExpenseTypeChange.bind(this)}
                                            filterOption={false}
                                            labelInValue={true}
                                            optionLabelProp='label'
                                            >
                                            {expense_types_options}
                                        </Select>
                                    )}
                                </FormItem>
                            </div>

                            {this.state.expense_selected && this.state.expense_selected.children.length > 0
                                ? <div className="col-md-4">
                                    <FormItem label="Sub Categoría" hasFeedback>
                                        {this.props.form.getFieldDecorator('subexpense_type', {
                                            rules: [{
                                                required: true,
                                                message: 'Por favor, elija el tipo de movimiento',
                                            }, {
                                                validator: this.checkSubExpenseType.bind(this)
                                            }]
                                        })(
                                            <Select 
                                                size='large'
                                                filterOption={false}
                                                labelInValue={true}
                                                optionLabelProp='label'
                                                >
                                                {this.state.expense_selected.children.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)}
                                            </Select>
                                        )}
                                    </FormItem>
                                </div>
                                : ''
                            }

                            {this.props.incomeType !== 'payments'
                                ? <div className="col-md-4">
                                    <FormItem label="Descripción">
                                        {this.props.form.getFieldDecorator('items', {
                                            rules: [{
                                                required: false,
                                                message: 'Por favor, ingrese al menos un elemento'
                                            }]
                                        })(<Input size='large' placeholder="Items" />)}
                                    </FormItem>

                                    <FormItem style={{marginTop: '-20px', marginBottom: '0'}}>
                                        {this.props.form.getFieldDecorator('voucher')(
                                            <Checkbox checked={this.props.form.getFieldValue('voucher') ? this.props.form.getFieldValue('voucher') : false}>Cuento con el comprobante</Checkbox>
                                        )}
                                    </FormItem>

                                    {this.props.form.getFieldValue('voucher')
                                        ? <Upload
                                            name="file"
                                            accept="image/*"
                                            showUploadList={true}
                                            action={config.externalUrl + "includes/upload.php"}
                                            beforeUpload={this.beforeUpload.bind(this)}
                                            headers={{
                                                "X-Parse-Application-Id": config.appId
                                            }}
                                            data={{
                                                type: 'docs',
                                                custom_name: this.state.file.uid + '.jpg'
                                            }}
                                        >
                                            <Button>
                                                <Icon type="upload" /> Click para subir el comprobante
                                            </Button>
                                        </Upload>
                                        : ''
                                    }

                                    {this.state.imageUrl 
                                        ? <span><Icon type="picture" /> <a href={config.externalUrl + 'uploads/docs/' + this.state.imageUrl} target="_blank">...{this.state.imageUrl}</a> </span>
                                        : ''
                                    }
                                </div>
                                : null
                            }
                        </div>

                        <div className="row marginBottom10">
                            <div className="col-md-12 heading">
                                Montos
                            </div>

                            {(this.state.expense_selected || this.state.subexpense_selected) || 
                            (this.state.expense_selected || this.state.subexpense_selected && this.props.incomeId)
                                ? <div>
                                    {(this.state.expense_selected.allow_income && !this.state.subexpense_selected) || 
                                    (this.state.subexpense_selected && this.state.subexpense_selected.allow_income)
                                        ? <div className="col-md-4">
                                            {this.state.expense_selected.allow_income}
                                            <FormItem label="Ingreso" hasFeedback>
                                                {this.props.form.getFieldDecorator('amount_income', {
                                                    rules: [{
                                                        required: false,
                                                    }, {
                                                        validator: this.checkAmount.bind(this)
                                                    }]
                                                })(
                                                    <NumberFormat 
                                                        thousandSeparator={true} 
                                                        prefix={'$'} 
                                                        className="ant-input ant-input-lg" />
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }
                                    
                                    {(this.state.expense_selected.allow_expense && !this.state.subexpense_selected) || 
                                    (this.state.subexpense_selected && this.state.subexpense_selected.allow_expense)
                                        ? <div className="col-md-4">
                                            <FormItem label="Gasto" hasFeedback>
                                                {this.props.form.getFieldDecorator('amount_expense', {
                                                    rules: [{
                                                        required: false,
                                                    }, {
                                                        validator: this.checkAmount.bind(this)
                                                    }]
                                                })(
                                                    <NumberFormat 
                                                        thousandSeparator={true} 
                                                        prefix={'$'} 
                                                        className="ant-input ant-input-lg" />
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }
                                </div>
                                : <div className="col-md-4 marginTop10" style={{color: 'darkgray'}}>Primero elija un movimiento</div>
                            }
                        </div>

                        <div className="row">
                            <div className="col-md-12 heading">
                                Notas
                            </div>

                            <div className="col-md-12 marginTop10">
                                <FormItem label="Escribe cualquier comentario" hasFeedback>
                                    {this.props.form.getFieldDecorator('notes')(<TextArea rows={3} />)}
                                </FormItem>
                            </div>
                        </div>

                        <div className="row text-center">
                            <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                Guardar
                            </Button>
                        </div>
                    </Spin>
                </Form>
            </div>
        )
    }
}

IncomeNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(IncomeNew))


// WEBPACK FOOTER //
// ./src/components/incomes/incomeNew.js